/**
 * Bundle checkout link generator
 */
(function() {
  const checkoutGenerator = (e) => {
          e.preventDefault();
          const bundleContainer = e.target.closest('[data-type="bundle"]'),
                bundleDataElement = bundleContainer.querySelector('[data-products]'),
                bundleData = JSON.parse(bundleDataElement.getAttribute('data-products')),
                abData = bundleDataElement.getAttribute('data-ab-variant'),
                hintContainer = bundleContainer.querySelector('[data-type="hint"]'),
                shakerCheckbox = bundleContainer.querySelector('[data-type="shaker"]');
          let checkoutItems = {},
              valid = true;

          hintContainer.classList.add('none');

          // Process shaker
          if (shakerCheckbox && shakerCheckbox.checked) {
            checkoutItems[bundleData.shaker] = 1;
          }

          // Process additional free product
          if (bundleData.free_product) {
            checkoutItems[bundleData.free_product] = 1;
          }

          // Process standard products
          if (bundleData.standard) {
            for (let i = 0; i < bundleData.standard.length; i++) {
              const standardProduct = bundleData.standard[i];
              if (!standardProduct.available) {
                valid = false;
                break;
              }
              if (checkoutItems[standardProduct.variant_id]) {
                checkoutItems[standardProduct.variant_id] += parseInt(standardProduct.quantity);
              }
              else {
                checkoutItems[standardProduct.variant_id] = parseInt(standardProduct.quantity);
              }
            }
          }
          
          // Process option products
          if (bundleData.option) {
            for (let i = 0; i < bundleData.option.length; i++) {
              const optionProduct = bundleData.option[i],
                    select_elements = bundleContainer.querySelectorAll('select[data-handle="' + optionProduct.handle + '"]');
              for (let k = 0; k < select_elements.length; k++) {
                const select_value = select_elements[k].value;
                if (select_value) {
                  const variant_id = optionProduct.variants[select_value];
                  if (checkoutItems[variant_id]) {
                    checkoutItems[variant_id] += 1;
                  }
                  else {
                    checkoutItems[variant_id] = 1;
                  }
                  select_elements[k].classList.remove('invalid');
                }
                else {
                  valid = false;
                  select_elements[k].classList.add('invalid');
                }
              }
            }
          }

          // Redirect to generated checkout
          let checkoutUrl = window.routes.cartUrl + '/';
          const keys = Object.keys(checkoutItems);
          for (let i = 0; i < keys.length; i++) {
            checkoutUrl += keys[i] + ':' + checkoutItems[keys[i]];
            if (i < keys.length - 1) {
              checkoutUrl += ',';
            }
          }
          if (bundleData.discount) {
            checkoutUrl += '?discount=' + bundleData.discount + '&attributes[_from]=sales-page';
          } else {
            checkoutUrl += '?attributes[_from]=sales-page';
          }
          if (bundleData.keyword) {
            checkoutUrl += '&attributes[_keyword]=' + encodeURIComponent(bundleData.keyword);
          }
          if (abData) {
            checkoutUrl += '&attributes[_ab-variant]=' + abData;
          }

          if (valid) {
            if (bundleData.new_tab === 'true') {
              window.open(checkoutUrl, '_blank');
            }
            else {
              window.open(checkoutUrl, '_self');
            }
          }
          else {
            hintContainer.classList.remove('none');
          }
        };

  // Add listeners to checkout buttons
  const bundles = document.querySelectorAll('[data-type="bundle"]');
  for (let i = 0; i < bundles.length; i++) {
    const checkoutButton = bundles[i].querySelector('button[data-action="checkout"]');
    if (checkoutButton) {
      checkoutButton.addEventListener('click', checkoutGenerator);
    }
  }
})();

/**
 * Content based on video progress
 */
(function() {
  const videoElement = document.querySelector('.SalesPageHero__VideoWrapper[data-wistia-id]');
  if (videoElement) {
    const wistiaId = videoElement.getAttribute('data-wistia-id'),
          delay = videoElement.hasAttribute('data-progress-based-content-time') ? parseInt(videoElement.getAttribute('data-progress-based-content-time')) : false,
          displaySections = () => {
            document.querySelectorAll('.vsl-none').forEach((section) => {
              section.classList.remove('vsl-none');
              const innerMasonry = section.querySelector('[data-masonry-grid="true"]');
              if (innerMasonry) innerMasonry.dispatchEvent(new CustomEvent('theme:masonry:change'));
            });
          };

    if (localStorage.getItem(`vsl_${location.pathname.split('/').pop()}_complete`) === 'true') {
      displaySections();
    }
    else {
      const player = document.querySelector(`wistia-player[media-id="${wistiaId}"]`);
      const onSecondChange = e => {
        if (e.detail.second >= delay) {
          displaySections();
          localStorage.setItem(`vsl_${location.pathname.split('/').pop()}_complete`, 'true');
          player.cancelFullscreen();
          player.removeEventListener('second-change', onSecondChange);
        }
      };
      if (delay !== false) player.addEventListener('second-change', onSecondChange);
    }
  }
})();

/**
 * Countdown elements
 */
(function() {
  const countdownElements = document.querySelectorAll('[data-timer-date]');
  if (!countdownElements.length) return;

  const search = new URLSearchParams(window.location.search);
  countdownElements.forEach((element) => {
    element.addEventListener('theme:timer:expired', () => {
      const headlineElement = element.querySelector('[data-timer-headline]');
      if (headlineElement && headlineElement.hasAttribute('data-timer-expired')) {
        headlineElement.innerText = headlineElement.getAttribute('data-timer-expired');
      }
    });
    if (element.getAttribute('data-timer-date') === 'expires' && search.has('expires')) {
      element.setAttribute('data-timer-date', search.get('expires'));
      element.closest('.Countdown').classList.remove('none');
      element.dispatchEvent(new CustomEvent('theme:timer:init'));
    }
  });
})();

/**
 * Tracking
 */
(function() {
  const urlParams = new URLSearchParams(document.location.search);
  const source = urlParams.has('source') ? urlParams.get('source').toLowerCase() : null;
  window.themeLayer = window.themeLayer || [];
  let salesPageType = 'default';
  if (window.vslSalesPage) {
    salesPageType = 'vsl';
  }
  else if (window.expiringSalesPage) {
    salesPageType = 'expiring';
  }
  window.themeLayer.push({
    event: 'sales_page_viewed',
    sales_page_type: salesPageType,
    variant_id: window.variantId,
    product_title: window.productTitle
  });
  if (source === 'survey') {
    window.themeLayer.push({ event: 'content_viewed', content_type: 'Survey' });
  }
  const offerObserver = new IntersectionObserver((entries) => {
    let intersecting = false;
    entries.forEach((entry) => {
      if (entry.isIntersecting && !intersecting) {
        window.themeLayer.push({ event: 'offer_viewed' });
        intersecting = true;
        offerObserver.disconnect();
      }
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('.SalesPageOffer .Offer__Item, .OfferSectionV2 .OfferSectionV2__OfferItem').forEach((element) => {
    offerObserver.observe(element);
  });
})();

/**
 * VSL video play tracking
 */
(function() {
  const videoElement = document.querySelector('.SalesPageHero__VideoWrapper[data-wistia-id]');
  if (!videoElement) return;
  
  const wistiaId = videoElement.getAttribute('data-wistia-id');

  const player = document.querySelector(`wistia-player[media-id="${wistiaId}"]`);
  const onPlay = () => {
    window.themeLayer = window.themeLayer || [];
    window.themeLayer.push({ event: 'content_viewed', content_type: 'VSL' });
    window.kameleoonQueue = window.kameleoonQueue || [];
    window.kameleoonQueue.push(['Kameleoon.API.Goals.processConversion', '359879']);
    player.removeEventListener('play', onPlay);
  };
  player.addEventListener('play', onPlay);
})();

(() => {
  // Hide sticky bar when offer is visible
  const offerSection = document.querySelector('.SalesPageOffer'),
        stickyCta = document.querySelector('.StickyCta');
  if (stickyCta && offerSection) {
    const observer = new IntersectionObserver(entries => {
      let shouldHide = false;
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          shouldHide = true;
        }
      });
      stickyCta.style.transform = shouldHide ? 'translateY(100%)' : 'translateY(0)';
      document.documentElement.style.setProperty('--sticky-cta-height', shouldHide ? '0' : `${stickyCta.offsetHeight}px`);
    }, {
      threshold: 0.2
    });
    observer.observe(offerSection);
    const footer = document.querySelector('#shopify-section-shop-footer');
    if (footer) observer.observe(footer);
    const heroCta = document.querySelector('.SalesPageHero a[href*="#angebot"]');
    if (heroCta) observer.observe(heroCta);
  }
})();

/**
 * Exit intent survey
 */
(() => {
  const surveyModal = document.querySelector('#modal-sales-page-exit-intent'),
        modalOpener = document.querySelector('[data-action="open-modal"][aria-controls="modal-sales-page-exit-intent"]'); // Button is needed on page load for ajax modal functionality
  if (sessionStorage.getItem('sales_page_exit_intent_shown') === "true" || !surveyModal || !modalOpener) return;

  const handleMouseleave = (e) => {
    if (sessionStorage.getItem('sales_page_exit_intent_shown') === "true") {
      document.body.removeEventListener('mouseleave', handleMouseleave);
      return;
    }
    if (e.clientY < 0) {
      modalOpener.click();
      sessionStorage.setItem('sales_page_exit_intent_shown', "true");
    }
  };
  
  document.body.addEventListener('mouseleave', handleMouseleave);
})();

/**
 * Review screenshots slider
 */
(() => {
  window.onDomReady(() => {
    const reviewSection = document.querySelector('.ReviewScreenshots'),
          sliderElement = reviewSection ? reviewSection.querySelector('.Slider') : null;
    if (!reviewSection || !sliderElement || !window.Slider) return;
    new Slider(sliderElement);
  });
})();

/**
 * Personalized offer
 */
(() => {
  if (window.salesPageExpired) {
    document.querySelectorAll('[data-offer] [href*="/cart/"]').forEach(button => {
      button.href = button.href.replace(/\?.*/, '');
    });
    return;
  }

  const search = new URLSearchParams(window.location.search);
  for (let i = 1; i <= 3; i++) {
    if (search.has(`discount${i}`)) {
      const cartButtons = document.querySelectorAll(`[data-offer="${i}"] [href*="/cart/"]`);
      cartButtons.forEach(button => {
        button.href = button.href.replace(/discount=[^&]+/, `discount=${search.get(`discount${i}`)}`);
      });
      const modalButtons = document.querySelectorAll(`[data-offer="${i}"] [data-action="open-modal"][aria-controls^="modal-offer"][aria-controls$="${i}"]`);
      modalButtons.forEach(button => {
        const modal = document.getElementById(button.getAttribute('aria-controls')),
              dataElement = modal.querySelector('[data-products]'),
              data = JSON.parse(dataElement.getAttribute('data-products'));
        data.discount = search.get(`discount${i}`);
        dataElement.setAttribute('data-products', JSON.stringify(data));
      });
    }
  }
})();

/**
 * Offer click tracking
 */
(() => {
  // Custom tracking is needed because Kameleoon does not recognize clicks on offer buttons with their native click tracking
  const offerButtons = document.querySelectorAll('a[data-modal-loading], button[data-action="checkout"]');
  offerButtons.forEach(button => {
    button.addEventListener('click', () => {
      window.themeLayer = window.themeLayer || [];
      window.themeLayer.push({ event: 'offer_clicked' });
    });
  });
})();